import { useEffect, useState } from "react";
import { getProfile } from "../services/profileService";
import { ProfileResponse } from "../Interfaces/ProfileTypes";

export function useProfile(employeeId: string) {
  const [data, setData] = useState<ProfileResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!employeeId) return;

    (async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await getProfile(employeeId);
        setData(res);
      } catch (err: any) {
        console.error("Erro ao buscar perfil:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    })();
  }, [employeeId]);

  return { data, loading, error };
}

export async function updateNotes(employeeId: string) {
  try {
    const res = await getProfile(employeeId);
    return res;
  } catch (err) {
    console.error("Erro ao buscar perfil:", err);
  }
}
